export default values => {
  let errors = {};
  if (!values.name) errors.name = 'Complete el nombre de la categoría';
  if (!values.description) errors.description = 'Complete la descripción de la categoría';
  return errors;
};
